function MyAccount() {
  return <>MyAccount</>;
}

export default MyAccount;
